import Omy from "../../Omy";
import { OmyConst } from "../../OmyConst";

let track;

const ACTOR_SPINE_EVENTS = {
  onKillEvent: "kill_event",
  onReviveEvent: "revive_event",
  onDestroyEvent: "destroy_event",
  onDownEvent: "down_event",
  onUpEvent: "up_event",
  onUpOutSideEvent: "up_out_event",
  onOverEvent: "over_event",
  onOutEvent: "out_event",
  onDragStartEvent: "drag_start_event",
  onDragStopEvent: "drag_stop_event",
  onDragUpdateEvent: "drag_update_event",
  onCompleteEvent: "complete_event",
  onSpineEventEvent: "event_event",
  onLoopEvent: "loop_event"
};

export default class OActorSpine extends PIXI.spine.Spine {
  constructor(spineData) {
    super(spineData);

    this._saveVisible = true;
    /**         * @type {Object}         */
    this.userData = null;
    /**         * @type {Boolean}         */
    this._active = true;
    this._oX = 0;
    this._oY = 0;
    this._oWidth = 0;
    this._oHeight = 0;

    this._putOnCache = true;

    /**         * @type {Array}         */
    this._externalMethodParams = null;
    /**         * @type {Function}         */
    this._externalMethod = null;
    this._isDrag = false;
    this._dragVertical = false;
    this._dragHorizontal = false;
    this._isStartDrag = false;
    this._isCheckInput = false;

    this._boundsRect = new OmyConst.Rectangle();
    this._localBoundsRect = new OmyConst.Rectangle();

    this._oType = OmyConst.OMY_ACTOR_SPINE;

    this._curIndex = 0;
    this._playing = false;
    this._skinName = null;
    this._removeOnEnd = false;
    this._countLoop = 0;
    this._totalLoop = Number.MAX_VALUE;
    this._aName = "animation";
    this.state.addListener({
      complete: this._onCompleteHandler.bind(this),
      event: this._onEventHandler.bind(this)
    });
    this.interactChild = false;
    this.setScale(1, 1);
    if (Omy.debugMode) {
      this._isOnDebugerUpdate = true;
      Omy.addUpdater(this._updateDebug, this);
    }
    this.aa_isRegOnDebug = false;
    this._inDebug = false;
    this.aa_anime = "";
    Omy.game.emit.on("game_no_active", this._onWorldOff, this);
    Omy.game.emit.on("game_active", this._onWorldOn, this);
    this._saveSpeed = -1;
    this._isPaused = false;
    this._destroyOnKill = true;
    this._nextUNull = false;
    this._saveUpdateTransform = this.updateTransform;
    this.updateTransform = () => {
      if (!this.parent) return;
      if (!this.transform) return;
      this._saveUpdateTransform();
    };
  }

  /**     * @private     */
  _onWorldOff() {
    this._saveSpeed = this.speed;
    this.speed = 0;
  }

  /**     * @private     */
  _onWorldOn() {
    this._nextUNull = true;
    if (this._saveSpeed >= 0) {
      this.speed = this._saveSpeed;
      this._saveSpeed = -1;
    }
  }

  /**     * @private     */
  _updateDebug() {
    if (this.aa_isRegOnDebug && !this._inDebug) {
      Omy.add.regDebugMode(this);
    } else if (!this.aa_isRegOnDebug && this._inDebug) {
      Omy.add.removeFromDebug(this);
    }
    if (this.aa_isRegOnDebug) {
      if (this.aa_anime.length) {
        this.aa_anime = (this.aa_anime.charAt(0) === "'") ? this.aa_anime.slice(1, this.aa_anime.length - 1) : this.aa_anime;
        this.gotoAndPlay(0, false, this.aa_anime);
        this.aa_anime = "";
      }
    }
  }

  /**     * @private     */
  _onCompleteHandler(trackEntry) {
    if (trackEntry.loop) {
      this.emit(ACTOR_SPINE_EVENTS.onLoopEvent, this);
      if (++this._countLoop >= this._totalLoop) {
        trackEntry.loop = false;
        this.stop();
        this.emit(ACTOR_SPINE_EVENTS.onCompleteEvent, this);
        if (this._removeOnEnd) {
          Omy.add.timer(0.0001, this.destroy, this);
        }
      }
    } else {
      this.emit(ACTOR_SPINE_EVENTS.onCompleteEvent, this);
      this._clearTimeData();
      if (this._removeOnEnd) {
        Omy.add.timer(0.0001, this.destroy, this);
      }
    }

  }

  /**     * @private     */
  _onEventHandler(entry, event) {
    this.emit(ACTOR_SPINE_EVENTS.onSpineEventEvent, this, event);
  }

  setDelayPlay(time = 0, looping = false, onComplete = null) {
    if (this._delayTimer) this._delayTimer.destroy();
    this._saveDelayLoop = looping;
    this._saveDelayOnComplete = onComplete;
    this._delayTimer = Omy.add.timer(time, this._onCompleteDelayPlay, this);
  }

  _onCompleteDelayPlay() {
    if (!this.visible) this.visible = true;
    this._delayTimer = null;
    this.play(this._saveDelayLoop);
    if (this._saveDelayOnComplete) {
      this._saveDelayOnComplete(this);
      this._saveDelayOnComplete = null;
    }
  }

  setDelayGotoAndPlay(time = 0, frame = 0, looping = false, onComplete = null) {
    if (this._delayTimer) this._delayTimer.destroy();
    this._saveDelayLoop = looping;
    this._saveDelayFrame = frame;
    this._saveDelayOnComplete = onComplete;
    this._delayTimer = Omy.add.timer(time, this._onCompleteDelayGotoAndPlay, this);
  }

  _onCompleteDelayGotoAndPlay() {
    if (!this.visible) this.visible = true;
    this._delayTimer = null;
    this.gotoAndPlay(this._saveDelayFrame, this._saveDelayLoop);
    if (this._saveDelayOnComplete) {
      this._saveDelayOnComplete(this);
      this._saveDelayOnComplete = null;
    }
  }

  addNext(aName, looping = false) {
    if (!aName) Omy.error("aName cannot be null");
    this._aName = aName;
    this.state.addAnimationByName(this._curIndex, this._aName, looping);
  }

  play(looping = false, aName = null) {
    this._playing = true;
    this._countLoop = 0;
    this._aName = aName || this._aName;
    this.autoUpdate = true;
    this.state.setAnimation(this._curIndex, this._aName, looping);
    this.update(0);
    this.skeleton.updateWorldTransform();
    return this;
  }

  stop() {
    this._clearTimeData();
    this._playing = false;
    this.autoUpdate = false;
    this.state.clearTracks();
    this.update(0);
    this.skeleton.updateWorldTransform();
    return this;
  }

  pause() {
    if (!this._isPaused) {
      this._isPaused = true;
      this._saveTimeScale = this.speed;
      this.speed = 0;
    }
    return this;
  }

  resume() {
    if (this._isPaused) {
      this._isPaused = false;
      this.speed = this._saveTimeScale;
    }
    return this;
  }

  gotoAndPlay(frame = 0, looping = false, aName = null) {
    this._playing = true;
    this._countLoop = 0;
    this._aName = aName || this._aName;
    this.autoUpdate = true;
    track = this.state.setAnimation(this._curIndex, this._aName, looping);
    if (track) {
      if (frame >= track.trackEnd)
        frame = 0;
      track.trackTime = frame;
    }
    this.update(0);
    this.skeleton.updateWorldTransform();
    return this;
  }

  gotoAndStop(frame = 0, aName = null) {
    this.stop();
    this._aName = aName || this._aName;
    track = this.state.setAnimation(this._curIndex, this._aName);
    if (track) {
      if (frame >= track.trackEnd)
        frame = 0;
      track.trackTime = frame;
    }
    this.update(0);
    this.skeleton.updateWorldTransform();
    return this;
  }

  /**
   * Play mix animation with starting main animation
   * @param {number} trackIndex
   * @param {string} aName
   * @param {number} frame=0
   * @param {boolean} looping=false
   * @return {OActorSpine}
   */
  playMixAnimation(trackIndex, aName, frame = 0, looping = false) {
    if (!this._playing) {
      console.error("Spine without active animation. Pls start main animation in this spine", this);
      return this;
    }
    if (trackIndex < 1) console.error("Pls set correct track index. Must to be bigger than 0", trackIndex, aName);
    !aName && console.error("Name of animation must to be not null", trackIndex, aName);
    track = this.state.setAnimation(trackIndex, aName, looping);
    if (track) {
      if (frame >= track.trackEnd)
        frame = 0;
      track.trackTime = frame;
      track.alpha = 1;
    }
    return this;
  }

  /**
   * Stop mix animation
   * @param {number} trackIndex
   * @return {OActorSpine}
   */
  stopMixAnimation(trackIndex) {
    if (!this._playing) {
      console.error("Spine without active animation. Pls start main animation in this spine", this);
      return this;
    }
    if (trackIndex < 1) console.error("Pls set correct track index. Must to be bigger than 0", trackIndex);
    track = this.state.setEmptyAnimation(trackIndex, 0);
    if (track) {
      track.trackTime = 0;
      track.alpha = 0;
    }
    return this;
  }

  reset() {
    this.skeleton.setToSetupPose();
    this.state.tracks = [];
    // this.state.setEmptyAnimation(0);
  }

  restart() {
    this.state.clearTracks();
    return this;
  }

  changeAnimation(aName) {
    if (!this.hasAnimation(aName)) return;
    this._aName = aName;
    if (this.playing) {
      let loop = this.loop;
      this.stop();
      this.play(loop);
    }
  }

  hasAnimation(aName) {
    return this.state.hasAnimation(aName);
  }

  setMixByName(aName1, aName2, delay = 0) {
    this.stateData.setMix(aName1, aName2, delay);
  }

  setSkin(skin) {
    if (skin && this._skinName != skin) {
      this._skinName = skin;
      this.skeleton.setSkinByName(skin);
      this.skeleton.setToSetupPose();
    }
  }

  /**
   * @param {PIXI.DisplayObject} child
   * @returns {boolean}
   */
  contains(child) {
    if (this.children == null) {
      return false;
    }

    return this.children.indexOf(child) >= 0;
  }

  /**     * @public     */
  kill() {
    this.emit(ACTOR_SPINE_EVENTS.onKillEvent, this);
    if (this._isOnDebugerUpdate) {
      this._isOnDebugerUpdate = false;
      Omy.removeUpdater(this._updateDebug, this);
    }
    if (!this._destroyOnKill) {
      this.stop();
      return;
    }
    return this.destroy();
  }

  /**     * @public     */
  revive() {
    this.emit(ACTOR_SPINE_EVENTS.onReviveEvent, this);
    if (Omy.debugMode && !this._isOnDebugerUpdate) {
      this._isOnDebugerUpdate = true;
      Omy.addUpdater(this._updateDebug, this);
    }
    return this;
  }

  /**     * @public     */
  destroy(options) {
    if (!this._active) return;
    options = options || { children: true, texture: false, baseTexture: false };
    if (this.parent)
      this.parent.removeChild(this);
    if (this._playing) {
      this.stop();
    }
    if (this._delayTimer) this._delayTimer.destroy();
    this.json = null;
    this._delayTimer = null;
    this._saveDelayOnComplete = null;
    this.autoUpdate = false;
    this._clearTimeData();
    if (this._isOnDebugerUpdate) {
      this._isOnDebugerUpdate = false;
      Omy.removeUpdater(this._updateDebug, this);
    }

    this._active = false;
    this.userData = null;
    this._boundsRect = null;
    this._localBoundsRect = null;
    this._isDrag = false;
    this._isStartDrag = false;
    if (this._listenMouseUp) {
      this._listenMouseUp = false;
      Omy.mouse.removeUpMouse(this._globalMouseUp, this);
    }
    this._eventData = null;
    this._findSlotSpriteList = null;

    if (this.input) {
      this.input = false;
    }
    this.removeAllListeners(ACTOR_SPINE_EVENTS.onDragStartEvent);
    this.removeAllListeners(ACTOR_SPINE_EVENTS.onDragStopEvent);
    this.removeAllListeners(ACTOR_SPINE_EVENTS.onDragUpdateEvent);
    this.removeAllListeners(ACTOR_SPINE_EVENTS.onDownEvent);
    this.removeAllListeners(ACTOR_SPINE_EVENTS.onOutEvent);
    this.removeAllListeners(ACTOR_SPINE_EVENTS.onOverEvent);
    this.removeAllListeners(ACTOR_SPINE_EVENTS.onUpEvent);
    this.removeAllListeners(ACTOR_SPINE_EVENTS.onUpOutSideEvent);
    this.removeAllListeners(ACTOR_SPINE_EVENTS.onCompleteEvent);
    this.removeAllListeners(ACTOR_SPINE_EVENTS.onSpineEventEvent);
    this.removeAllListeners(ACTOR_SPINE_EVENTS.onLoopEvent);
    this.emit(ACTOR_SPINE_EVENTS.onDestroyEvent, this);
    this.removeAllListeners(ACTOR_SPINE_EVENTS.onDestroyEvent);
    this.removeAllListeners(ACTOR_SPINE_EVENTS.onKillEvent);
    this.removeAllListeners(ACTOR_SPINE_EVENTS.onReviveEvent);
    Omy.game.emit.off("game_no_active", this._onWorldOff, this);
    Omy.game.emit.off("game_active", this._onWorldOn, this);

    this._externalMethod = null;
    this._externalMethodParams = null;
    this.renderable = false;
    this.visible = false;

    super.destroy(options);

    this.spineData = null;

    if (this.skeleton) {
      this.skeleton._updateCache = null;
      this.skeleton.updateCacheReset = null;
      this.skeleton.data = null;
      this.skeleton.bones = null;
      this.skeleton.slots = null;
      this.skeleton.drawOrder = null;
      this.skeleton.ikConstraints = null;
      this.skeleton.transformConstraints = null;
      this.skeleton.pathConstraints = null;
    }
    this.skeleton = null;

    if (this.stateData) {
      this.stateData.skeletonData = null;
    }
    this.stateData = null;

    if (this.state) {
      this.state.clearTracks();
      this.state.clearListeners();
      this.state.tracks = null;
      this.state.events = null;
      this.state.listeners = null;
      this.state.queue = null;
      this.state.propertyIDs = null;
      this.state.mixingTo = null;
      this.state.trackEntryPool = null;
      this.state.data = null;
    }
    this.state = null;

    this.slotContainers = null;
    this.tempClipContainers = null;
    this._saveUpdateTransform = null;
    return this;
  }

  /**     * @public     */
  update(dt) {
    if (!this.active) return;
    if (this._nextUNull) {
      dt = 0;
      this._nextUNull = false;
    }
    super.update(dt);
    if (this._timeData) {
      let time = this.currentFrame;
      for (let timePos in this._timeData) {
        if (Number(timePos) <= time) {
          this._timeData[timePos]();
          this._timeData[timePos] = null;
          delete this._timeData[timePos];
        }
      }
    }
    if (this._isStartDrag) {
      if (this._eventData.global.x !== this._dragSaveX || this._eventData.global.y !== this._dragSaveY) {
        if (this._dragHorizontal) {
          this.x = this._oX + this._eventData.global.x - this._dragSaveX;

          if (this._oX < this._dragXMin) {
            this.x = this._dragXMin;
          } else if (this._oX > this._dragXMax) {
            this.x = this._dragXMax;
          }
        }
        if (this._dragVertical) {
          this.y = this._oY + this._eventData.global.y - this._dragSaveY;

          if (this._oY < this._dragYMin) {
            this.y = this._dragYMin;
          } else if (this._oY > this._dragYMax) {
            this.y = this._dragYMax;
          }
        }
        this._dragSaveX = this._eventData.global.x;
        this._dragSaveY = this._eventData.global.y;
        this.emit(ACTOR_SPINE_EVENTS.onDragUpdateEvent, this);
        if (!Omy.mouse.isDown) this._upOutSide();
      }
    }
    if (this._findSlotSpriteList) {
      for (let findKey in this._findSlotSpriteList) {
        if (findKey === "countActive") continue;
        const findSprite = this.skeleton.findSlot(findKey)?.currentSprite;
        if (findSprite) {
          this._findSlotSpriteList[findKey].apply(null, [findSprite, this]);
          this._findSlotSpriteList[findKey] = null;
          delete this._findSlotSpriteList[findKey];
          this._findSlotSpriteList["countActive"]--;
        }
      }
      if (this._findSlotSpriteList["countActive"] <= 0) this._findSlotSpriteList = null;
    }
  }

  autoUpdateTransform() {
    if (!this.parent) return;
    super.autoUpdateTransform();
  }

  _down(event) {
    if (this._isDrag) {
      this._eventData = event.data;
      this._dragSaveX = this._eventData.global.x;
      this._dragSaveY = this._eventData.global.y;
      this._isStartDrag = true;
      this.emit(ACTOR_SPINE_EVENTS.onDragStartEvent, this);
    }

    this.emit(ACTOR_SPINE_EVENTS.onDownEvent, this);
  }

  _over() {
    this.emit(ACTOR_SPINE_EVENTS.onOverEvent, this);
  }

  _out() {
    this.emit(ACTOR_SPINE_EVENTS.onOutEvent, this);
  }

  _upOutSide() {
    this._out();
    this.emit(ACTOR_SPINE_EVENTS.onUpOutSideEvent, this);
  }

  _up() {
    this.emit(ACTOR_SPINE_EVENTS.onUpEvent, this);
    if (this._externalMethod != null)
      this._externalMethod.apply(null, this._externalMethodParams);
  }

  _globalMouseUp() {
    if (this._isDrag && this._isStartDrag) {
      this._eventData = null;
      this._isStartDrag = false;
      this.emit(ACTOR_SPINE_EVENTS.onDragStopEvent, this);
    }
  }

  /** @private */
  _clearTimeData() {
    if (this._timeData) {
      for (let timePos in this._timeData) {
        delete this._timeData[timePos];
      }
      this._timeData = null;
    }
  }

  setXY(ax, ay) {
    this._oX = ax;
    this._oY = ay;
    this.position.set(ax, ay);
  }

  setSize(ax, ay) {
    this.width = ax;
    this.height = ay;
  }

  setScale(ax, ay) {
    this.scale.set(ax, ay);
  }

  setAnchor(ax, ay) {
    this.anchor.set(ax, ay);
  }

  setPivot(ax, ay) {
    this.pivot.set(ax, ay);
    this.x = this._oX + ax;
    this.y = this._oY + ay;
  }

  /**
   * @param {Function}eMethod
   * @param {Array}methodParams
   */
  externalMethod(eMethod, methodParams) {
    if (!this.input)
      this.input = true;
    this._externalMethod = eMethod;
    this._externalMethodParams = methodParams;
  }

  boundsDragRect(rXMin = NaN, rYMin = NaN, rXMax = NaN, rYMax = NaN) {
    if (!isNaN(rXMin))
      this._dragXMin = rXMin;
    if (!isNaN(rYMin))
      this._dragYMin = rYMin;
    if (!isNaN(rXMax))
      this._dragXMax = rXMax;
    if (!isNaN(rYMax))
      this._dragYMax = rYMax;
  }

  /** @public */
  addCallbackInTime(time, callback) {
    if (!this._timeData) this._timeData = {};
    this._timeData[time] = callback;
  }

  /** @public */
  removeCallbackInTime(time) {
    if (!this._timeData || !this._timeData[time]) return;
    delete this._timeData[time];
  }

  addOver(func, context, once) {
    if (!this.input)
      this.input = true;
    this._addNewEvent(ACTOR_SPINE_EVENTS.onOverEvent, func, context, once);
  }

  addOut(func, context, once) {
    if (!this.input)
      this.input = true;
    this._addNewEvent(ACTOR_SPINE_EVENTS.onOutEvent, func, context, once);
  }

  addDown(func, context, once) {
    if (!this.input)
      this.input = true;
    this._addNewEvent(ACTOR_SPINE_EVENTS.onDownEvent, func, context, once);
  }

  addUp(func, context, once) {
    if (!this.input)
      this.input = true;
    this._addNewEvent(ACTOR_SPINE_EVENTS.onUpEvent, func, context, once);
  }

  addUpOutSide(func, context, once) {
    if (!this.input)
      this.input = true;
    this._addNewEvent(ACTOR_SPINE_EVENTS.onUpOutSideEvent, func, context, once);
  }

  addDragUpdate(func, context, once) {
    this._addNewEvent(ACTOR_SPINE_EVENTS.onDragUpdateEvent, func, context, once);
  }

  addDragStart(func, context, once) {
    this._addNewEvent(ACTOR_SPINE_EVENTS.onDragStartEvent, func, context, once);
  }

  addDragStop(func, context, once) {
    this._addNewEvent(ACTOR_SPINE_EVENTS.onDragStopEvent, func, context, once);
  }

  addKill(func, context, once) {
    this._addNewEvent(ACTOR_SPINE_EVENTS.onKillEvent, func, context, once);
  }

  addRevive(func, context, once) {
    this._addNewEvent(ACTOR_SPINE_EVENTS.onReviveEvent, func, context, once);
  }

  addDestroy(func, context, once) {
    this._addNewEvent(ACTOR_SPINE_EVENTS.onDestroyEvent, func, context, once);
  }

  /**     * @private     */
  _addNewEvent(event, func, context, once = false) {
    if (once)
      this.once(event, func, context);
    else
      this.on(event, func, context);
  }

  addComplete(func, context, once) {
    this._addNewEvent(ACTOR_SPINE_EVENTS.onCompleteEvent, func, context, once);
  }

  addSpineEvent(func, context, once) {
    this._addNewEvent(ACTOR_SPINE_EVENTS.onSpineEventEvent, func, context, once);
  }

  addLoop(func, context, once = false) {
    this._addNewEvent(ACTOR_SPINE_EVENTS.onLoopEvent, func, context, once);
  }

  removeOver(func, context) {
    if (!func) this.removeListener(ACTOR_SPINE_EVENTS.onOverEvent);
    else this.removeListener(ACTOR_SPINE_EVENTS.onOverEvent, func, context);
  }

  removeOut(func, context) {
    if (!func) this.removeListener(ACTOR_SPINE_EVENTS.onOutEvent);
    else this.removeListener(ACTOR_SPINE_EVENTS.onOutEvent, func, context);
  }

  removeDown(func, context) {
    if (!func) this.removeListener(ACTOR_SPINE_EVENTS.onDownEvent);
    else this.removeListener(ACTOR_SPINE_EVENTS.onDownEvent, func, context);
  }

  removeUp(func, context) {
    if (!func) this.removeListener(ACTOR_SPINE_EVENTS.onUpEvent);
    else this.removeListener(ACTOR_SPINE_EVENTS.onUpEvent, func, context);
  }

  removeUpOutSide(func, context) {
    if (!func) this.removeListener(ACTOR_SPINE_EVENTS.onUpOutSideEvent);
    else this.removeListener(ACTOR_SPINE_EVENTS.onUpOutSideEvent, func, context);
  }

  removeDragUpdate(func, context) {
    if (!func) this.removeListener(ACTOR_SPINE_EVENTS.onDragUpdateEvent);
    else this.removeListener(ACTOR_SPINE_EVENTS.onDragUpdateEvent, func, context);
  }

  removeDragStart(func, context) {
    if (!func) this.removeListener(ACTOR_SPINE_EVENTS.onDragStartEvent);
    else this.removeListener(ACTOR_SPINE_EVENTS.onDragStartEvent, func, context);
  }

  removeDragStop(func, context) {
    if (!func) this.removeListener(ACTOR_SPINE_EVENTS.onDragStopEvent);
    else this.removeListener(ACTOR_SPINE_EVENTS.onDragStopEvent, func, context);
  }

  removeComplete(func, context) {
    if (!func) this.removeListener(ACTOR_SPINE_EVENTS.onCompleteEvent);
    else this.removeListener(ACTOR_SPINE_EVENTS.onCompleteEvent, func, context);
  }

  removeSpineEvent(func, context) {
    if (!func) this.removeListener(ACTOR_SPINE_EVENTS.onSpineEventEvent);
    else this.removeListener(ACTOR_SPINE_EVENTS.onSpineEventEvent, func, context);
  }

  removeLoop(func, context) {
    if (!func) this.removeListener(ACTOR_SPINE_EVENTS.onLoopEvent);
    else this.removeListener(ACTOR_SPINE_EVENTS.onLoopEvent, func, context);
  }

  removeKill(func, context) {
    if (!func) this.removeListener(ACTOR_SPINE_EVENTS.onKillEvent);
    else this.removeListener(ACTOR_SPINE_EVENTS.onKillEvent, func, context);
  }

  removeRevive(func, context) {
    if (!func) this.removeListener(ACTOR_SPINE_EVENTS.onReviveEvent);
    else this.removeListener(ACTOR_SPINE_EVENTS.onReviveEvent, func, context);
  }

  removDestroy(func, context) {
    this.removeDestroy(func, context);
  }

  removeDestroy(func, context) {
    if (!func) this.removeListener(ACTOR_SPINE_EVENTS.onDestroyEvent);
    else this.removeListener(ACTOR_SPINE_EVENTS.onDestroyEvent, func, context);
  }

  /**
   * find child in spine actor by name
   * @param {String}str
   * @returns {null|PIXI.Container|PIXI.Sprite}
   */
  getSpineChildByName(str) {
    return this._findChildByName(this, str);
  }

  /**@private
   * @param {PIXI.Container}container
   * @param {String}str
   * @returns {null|PIXI.Container|PIXI.Sprite}
   */
  _findChildByName(container, str) {
    let child, find = null;
    for (let i = 0; i < container.children.length; i++) {
      child = container.children[i];
      if (child.attachment?.name === str) {
        find = child;
        break;
      }
      if (child.children?.length) {
        find = this._findChildByName(child, str);
        if (find) break;
      }
    }
    return find;
  }

  /**
   * find bone from skeleton
   * @param {String}boneName
   * @returns {null|PIXI.spine.Bone}
   */
  findBone(boneName) {
    return this.skeleton?.findBone(boneName);
  }

  /**
   * find slot from skeleton
   * @param {String}slotName
   * @returns {null|PIXI.spine.Slot}
   */
  findSlot(slotName) {
    return this.skeleton?.findSlot(slotName);
  }

  /**
   * find current sprite on slot from skeleton
   * @param {String}slotName
   * @param {Boolean}force, default=false
   * @param {Function}callback, default=null
   * @returns {null|PIXI.Sprite}
   */
  findCurrentSlotSprite(slotName, force = false, callback = null) {
    const findSprite = this.skeleton?.findSlot(slotName)?.currentSprite;
    if (findSprite) return findSprite;
    if (!force || !callback) return null;
    if (!this._findSlotSpriteList) this._findSlotSpriteList = {};
    if (!this._findSlotSpriteList[slotName])
      this._findSlotSpriteList["countActive"] = (this._findSlotSpriteList.hasOwnProperty("countActive")) ? this._findSlotSpriteList["countActive"] + 1 : 1;
    this._findSlotSpriteList[slotName] = callback;
  }

//---------------------------------------
/// ACCESSOR
//--------------------------------------

  get active() {
    return this._active;
  }

  get scaleX() {
    return this.scale.x;
  }

  set scaleX(value) {
    this.scale.x = value;
  }

  get scaleY() {
    return this.scale.y;
  }

  set scaleY(value) {
    this.scale.y = value;
  }

  get pivotX() {
    return this.pivot.x;
  }

  set pivotX(value) {
    this.pivot.x = value;
  }

  get pivotY() {
    return this.pivot.y;
  }

  set pivotY(value) {
    this.pivot.y = value;
  }

  get anchorX() {
    return this.anchor.x;
  }

  set anchorX(value) {
    this.anchor.x = value;
  }

  get anchorY() {
    return this.anchor.y;
  }

  set anchorY(value) {
    this.anchor.y = value;
  }

  get localLeft() {
    return this._localBoundsRect.left;
  }

  get localRight() {
    return this._localBoundsRect.right;
  }

  get localTop() {
    return this._localBoundsRect.top;
  }

  get localBottom() {
    return this._localBoundsRect.bottom;
  }

  get localWidth() {
    return this._localBoundsRect.width;
  }

  get localHeight() {
    return this._localBoundsRect.height;
  }

  get globalLeft() {
    return this.getGlobalPosition().x + this.localLeft;
  }

  get globalTop() {
    return this.getGlobalPosition().y + this.localTop;
  }

  get worldX() {
    return this.getGlobalPosition().x;
  }

  get worldY() {
    return this.getGlobalPosition().y;
  }

  get x() {
    this._oX = super.x;
    return this._oX;
  }

  set x(value) {
    super.x = this._oX = value;
  }

  get y() {
    this._oY = super.y;
    return this._oY;
  }

  set y(value) {
    super.y = this._oY = value;
  }

  get height() {
    this._oHeight = super.height;
    return this._oHeight;
  }

  set height(value) {
    return super.height = this._oHeight = value;
  }

  get width() {
    this._oWidth = super.width;
    return this._oWidth;
  }

  set width(value) {
    return super.width = this._oWidth = value;
  }

  get oType() {
    return this._oType;
  }

  get input() {
    return this._isCheckInput;
  }

  set input(value) {
    if (this.input) {
      this.interactive = value;
    } else if (value) {
      this._isCheckInput = true;
      this.interactive = true;
      this.on("pointerdown", this._down, this);
      this.on("pointerup", this._up, this);
      this.on("pointerupoutside", this._upOutSide, this);
      this.on("pointerover", this._over, this);
      this.on("pointerout", this._out, this);
    }
  }

  set drag(value) {
    if (!this.input)
      this.input = true;

    this._isDrag = value;
    this._listenMouseUp = value;
    (this._listenMouseUp) ? Omy.mouse.addUpHandler(this._globalMouseUp, this) : Omy.mouse.removeUpMouse(this._globalMouseUp, this);
    this._dragVertical = true;
    this._dragHorizontal = true;
  }

  set allowHorizontalDrag(value) {
    this._dragHorizontal = value;
  }

  set allowVerticalDrag(value) {
    this._dragVertical = value;
  }

  set removeOnEnd(value) {
    this._removeOnEnd = value;
  }

  get loopCount() {
    return this._countLoop;
  }

  set totalLoop(value) {
    this._totalLoop = value;
  }

  get playing() {
    return this._playing;
  }

  get loop() {
    if (!this.state.getCurrent(this._curIndex)) return false;
    return this.state.getCurrent(this._curIndex).loop;
  }

  set loop(value) {
    if (!this.state.getCurrent(this._curIndex)) return;
    this.state.getCurrent(this._curIndex).loop = value;
  }

  get currentFrame() {
    if (!this.state || !this.state.getCurrent(this._curIndex)) return 0;
    return this.state.getCurrent(this._curIndex).getAnimationTime();
  }

  /**
   * @desc return spine animation duration
   */
  get frameTotal() {
    if (!this.state.getCurrent(this._curIndex)) return 0;
    return this.state.getCurrent(this._curIndex).animation.duration;
  }

  get animationName() {
    return this._aName;
  }

  get speed() {
    return this.state.timeScale;
  }

  set speed(value) {
    this.state.timeScale = value;
  }

  set interactChild(value) {
    this.interactiveChildren = value;
  }

  set putOnCache(value) {
    this._putOnCache = value;
  }

  get isPaused() {
    return this._isPaused;
  }

  set destroyOnKill(value) {
    this._destroyOnKill = value;
  }

  get correctTrackIndex() {
    return this._curIndex;
  }

  set correctTrackIndex(value) {
    this._curIndex = value;
  }
}
